import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import { useSeo } from "@/lib/seo";
import { Comparison } from "@/components/landing/Comparison";
import { AlgoCore } from "@/components/landing/AlgoCore";
import { Footer } from "@/components/landing/Footer";

export default function Compare() {
  useSeo({
    title: "TradrQuant vs Other Crypto Platforms | Compare",
    description: "How TradrQuant compares to other crypto trading platforms on price, transparency and tools, plus the rule-based engine behind the signals.",
    path: "/compare",
  });
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <div data-testid="compare-page" className="grain relative min-h-screen bg-[#0A0A0A] text-white overflow-x-hidden">
      <header className="sticky top-0 z-50 border-b border-white/10 bg-[#0A0A0A]/90 backdrop-blur-xl">
        <div className="mx-auto max-w-[1400px] px-5 md:px-12 h-14 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2.5 group">
            <img src="/tq-logo.png?v=3" alt="TradrQuant" className="h-[22px] w-auto transition-transform duration-300 group-hover:scale-105" />
            <span data-testid="wordmark" className="tq-wordmark text-[#ECEBE4] text-[19px] sm:text-[21px]">Tradr<span className="tq-q">Q</span>uant</span>
          </Link>
          <Link to="/" data-testid="compare-back-btn" className="inline-flex items-center gap-1.5 border border-white/15 px-3 py-2 font-mono text-[11px] uppercase tracking-[0.2em] text-white/60 transition-colors duration-300 hover:border-white/40 hover:text-white">
            <ChevronLeft size={14} /> cd ~/home
          </Link>
        </div>
      </header>
      <Comparison />
      <AlgoCore />
      <Footer />
    </div>
  );
}
